import { useQuery } from "@tanstack/react-query";
import Api from "src/Config";
import { createContext, FunctionComponent, ReactElement, useMemo } from "react";

export const MostUsedCheckContext = createContext(null);

type Props = {
  children: ReactElement;
};

const MostUsedCheckProvider: FunctionComponent<Props> = ({ children }) => {
  const { data, isLoading, error, isFetching } = useQuery({
    queryKey: ["most_used_check"],
    staleTime: 30000,
    queryFn: async () => {
      const {
        data: { data },
      } = await Api.get(`overview?keyword=most-used-check`);

      return data;
    },
  });

  const contextValue = useMemo(
    () => ({
      data,
      isLoading,
      isFetching,
      error,
    }),
    [isLoading, data, error, isFetching],
  );
  return (
    <MostUsedCheckContext.Provider value={contextValue}>
      {children}
    </MostUsedCheckContext.Provider>
  );
};

export default MostUsedCheckProvider;
